<template>
    <!-- 校区管理 -->
    <div class="campus-list">
        <div class="conditionSearchBox" v-if="!isSelect">
            <div class="conditionItem">
                <el-input v-model="params.condition.name" placeholder="校区名称" clearable></el-input>
            </div>
            <div class="conditionItem">
                <el-button type="primary" plain icon="el-icon-search" @click="search">搜索</el-button>
                <el-button type="" icon="el-icon-refresh" @click="reset">重置</el-button>
            </div>
        </div>
        <div>
            <el-button type="primary" icon="el-icon-plus" v-if="!isSelect" @click="openCampusDialog('')">新增校区</el-button>
            <el-button type="primary" plain icon="el-icon-delete" @click="isSelect = true" v-if="!isSelect">批量删除</el-button>
            <el-button type="primary" v-if="isSelect" @click="openDeletecampus('')" :disabled="selection.length === 0">批量删除 ({{selection.length}})</el-button>
            <el-button type="primary" plain v-if="isSelect" @click="cancelDelete">取消批量删除</el-button>
        </div>
        <div class="mt-15">
            <el-table :data="tableData" border class="table-fixed-col" v-loading="contentLoading" @selection-change="handleSelectionChange" ref="table" :row-key="getRowKey">
                <el-table-column type="selection" v-if="isSelect" fixed key="selection" class-name="selection" align="right" :width="getTableHeaderWidthByCheckCol(isSelect)"></el-table-column>
                <el-table-column label="序号" :width="getTableHeaderWidthByOrderCol(isSelect)" fixed align="center" key="sort">
                    <template slot-scope="scope">
                        <TableSort :index="scope.$index" :page="params.page" :pagesize="params.pagesize" />
                    </template>
                </el-table-column>
                <el-table-column prop="name" label="校区名称" fixed align="center" width="200" key="name" show-overflow-tooltip></el-table-column>
                <el-table-column prop="location" label="所在地区" align="center" width="250" key="location"></el-table-column>
                <el-table-column prop="address" label="具体地址" align="center" min-width="400" key="address" show-overflow-tooltip></el-table-column>
                <el-table-column prop="" label="操作" fixed="right" align="right" :width="getTableHeaderWidthByOpButton2()" key="edit" v-if="!isSelect">
                    <template slot-scope="scope">
                        <div class="color-brand flex jc-sa ai-c pointer">
                            <p @click="openCampusDialog(scope.row.code)">编辑</p>
                            <p @click="openDeletecampus(scope.row)">删除</p>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
            <Page v-if="total > 0" @pageChange="pageChange" @pagesizeChange="pagesizeChange" :total="total" :page="params.page" :pagesize="params.pagesize" />
        </div>
        <!-- 新增编辑 -->
        <CampusDialog ref="CampusDialog" @saveSuccess="saveSuccess"></CampusDialog>
        <!-- 删除 -->
        <!-- <Deletecampus ref="Deletecampus" @saveSuccess="saveSuccess"></Deletecampus> -->
    </div>
</template>
<script>
import { getTableDefaultPageSize } from '@/assets/measAssets/js/tools.js'
import TableSort from '@/components/measComponents/tableSort/tableSort.vue'
import Page from '@/components/measComponents/page/page.vue'
import {
  getCampusList,
  updateCampusStatus
} from '@/api/measApi/campusManage.js'
import CampusDialog from './components/campusDialog.vue'
// import Deletecampus from './components/deleteCampus.vue'
export default {
  data() {
    return {
      params: {
        condition: {
          name: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      },
      isSelect: false,
      tableData: [],
      total: 0,
      selection: [],
      contentLoading: false
    }
  },
  components: {
    TableSort,
    Page,
    CampusDialog
    // Deletecampus
  },
  created() {
    this.getCampusList()
  },
  methods: {
    //   获取表格数据
    getCampusList() {
      this.contentLoading = true
      getCampusList(this.params).then(res => {
        if (res.code === '000') {
          this.tableData = res.data
          this.total = res.pageinfo.rowcount
          this.contentLoading = false
        }
      })
    },
    // 搜索
    search() {
      this.params.page = 1
      this.getCampusList()
    },
    // 重置
    reset() {
      this.params = {
        condition: {
          name: ''
        },
        orderbyname: '',
        orderbyorder: '',
        page: 1,
        pagesize: getTableDefaultPageSize()
      }
      this.getCampusList()
    },
    // 分页
    pageChange(page) {
      this.params.page = page
      this.getCampusList()
    },
    pagesizeChange(size) {
      this.params.page = 1
      this.params.pagesize = size
      this.getCampusList()
    },
    // 多选
    getRowKey(row) {
      return row.code
    },
    getdisabled(row) {
      return row.isedit
    },
    // 选择
    handleSelectionChange(selection) {
      this.selection = selection
    },
    // 取消批量删除
    cancelDelete() {
      this.isSelect = false
      this.$refs.table.clearSelection()
      this.selection = []
    },
    // 打开新增弹窗
    openCampusDialog(code) {
      this.$refs.CampusDialog.handleOpen(code)
    },
    // 保存成功
    saveSuccess() {
      this.params.page = 1
      this.getCampusList()
      this.isSelect = false
    },
    // 删除校区
    openDeletecampus(row) {
      this.$confirm('校区删除后将不在前台展示，继续吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        customClass: 'measElMessage'
      })
        .then(() => {
          let code = ''
          if (row) {
            code = row.code
          } else {
            let selectionCode = []
            this.selection.map(item => {
              selectionCode.push(item.code)
            })
            code = selectionCode.join(',')
          }
          updateCampusStatus({ code: code }).then(res => {
            if (res.code === '000') {
              this.$message.success(res.msg)
              this.params.page = 1
              this.getCampusList()
              this.isSelect = false
            }
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          })
        })
    }
  }
}
</script>
<style lang="scss" scoped>
::v-deep .el-table__empty-block {
  background: none;
}
</style>

